<!-- BOM物料 -->
<template>
  <BaseFormItem
    class="buy_bom"
    :label="fields.label"
    :isShowLabelTitle="false"
    :labelTips="tips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <!-- BOM文件、坐标文件上传 -->
    <div v-show="[1, 2, 4].includes(buyBom)" class="buy_bom__upload">
      <div class="buy_bom__upload__list">
        <div class="buy_bom__upload__item">
          <UploadAndAnalyzeNew
            ref="coordFileRef"
            :pcbFileAnalyzeStatus="pcbFileAnalyzeStatus"
            key="coordFile"
            :type="val === 4 ? 'one_stop' : 'smt'"
            :fileUrl="smtFile.url"
            :fileName="smtFile.name"
            :fileType="1"
            :accept="getUploadAccept('coord')"
            :tips="tips"
            :analyzeFile="analyzeFile"
            @change="handleSmtFileChange"
            @beforeLogin="() => $emit('beforeLogin')"
            @downloadTemplateUrl="downloadTemplateUrl"
          />
        </div>
      </div>
      
    </div>
  </BaseFormItem>
</template>

<script>
import UploadAndAnalyzeNew from '../components/uploadAndAnalyzeNew'

import { getSMTFields } from '@@/utils/getFields'
import { bomSmtTemplateDownload } from '@@/api/pcba'
import {  isMyCenterSite } from '@@/utils/is'

export default {
  props: {
    value: {
      type: [String, Number],
      default: 1
    },
    smtFile: {
      type: Object,
      default: () => ({})
    },
    customPcbBan: {
      type: Number,
      default: 1
    },
    pcbFileAnalyzeStatus: {
      type: Number,
      default: 0
    },
    analyzeFile: {
      type: String,
      default: ''
    },
    // 添加buy_bom值，用于判断是否需要显示上传区域
    buyBom: {
      type: [String, Number],
      default: 1
    }
  },
  components: {
    UploadAndAnalyzeNew
  },
  data() {
    return {
      val: this.value || 1,
      currentItem: {},
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('coord_file')
    },
    // 非 自助匹配选型 时，坐标文件可以上次压缩文件
    canUploadZip() {
      return this.val !== 4
    },
    tips(){
      let result =  this.val !== 4 ? '.zip、.rar、.xls、.xlsx、.csv、.txt 格式 (50M以内)' : '.xls、.xlsx、.csv、.txt格式 (50M以内)'
      return result
    },
  },
  methods: {
    getUploadAccept(type) {
      // coord 坐标文件 bom BOM文件
      if(isMyCenterSite) {
        return '*'
      }
      if(type === 'coord') {
        return this.canUploadZip ? '.zip,.rar,.xls,.xlsx,.csv,.txt' : '.xls,.xlsx,.csv,.txt'
      }
      // bom默认就是组件内部支持格式所以返回undefined就行
    },
    // BOM、SMT模板下载
    downloadTemplateUrl(downloadType) {
      bomSmtTemplateDownload({ downloadType })
        .then(res => {
          if (!res) return
          const { retCode, result } = res
          if (retCode === 0) {
            window.open(result)
          }
        })
    },
    // 坐标文件上传成功
    handleSmtFileChange(data) {
      this.$emit('smtFileChange', data)
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    },
    setFile(data) {
      this.$refs['coordFileRef'].setFile(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';



.buy_bom {
  .buy_bom__upload {
    position: relative;
    box-sizing: border-box;
    width: 630px;
    // margin-top: 5px;
    // padding: 12px 18px;
    border-radius: $--border-radius-base;
    // border: 1px dashed $--form-color-base;
    // background-color: $--background-base;
  }
  
}
</style>